<template>
    <v-ons-toast :visible.sync="visible" animation="ascend">
        {{ message }}
        <button @click="clear">ok</button>
    </v-ons-toast>
</template>
<script>
import Vuex from 'vuex'

export default {
    name: 'notification',

    data () {
        return {
            visible: false,
        }
    },

    watch: {
        timestamp() {
            this.visible = true;
            setTimeout(() => {
                this.visible = false;
            }, 3000)
        }
    },

    computed: {
        ...Vuex.mapGetters('notification', {
            message: 'message',
            type: 'type',
            timestamp: 'timestamp',
        })
    },

    methods: {
        ...Vuex.mapActions('notification', {
            push: 'push',
        }),

        clear() {
            this.visible = false;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/partials/Notification.vue